/**
 * Periodekeuzes die door meerdere statistiekkaarten gedeeld worden.
 * Stond eerst als lokale constante in DistributionCharts.
 */
export const MONTHS = [
  { value: "all", label: "Alle maanden" },
  { value: "01", label: "Januari" },
  { value: "02", label: "Februari" },
  { value: "03", label: "Maart" },
  { value: "04", label: "April" },
  { value: "05", label: "Mei" },
  { value: "06", label: "Juni" },
  { value: "07", label: "Juli" },
  { value: "08", label: "Augustus" },
  { value: "09", label: "September" },
  { value: "10", label: "Oktober" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];
